import React, { useRef } from 'react';
import Box from 'components/elements/Box';
import { IFAQItem } from './shared/shared';
import {
  CancelButton,
  PrimaryButton,
  ModalContentWrapper,
  ModalTitle,
  LabelArea,
  Input,
  TextArea,
} from './shared/FAQ.styles';

interface ICreateNewFAQModalProps {
  onSave: (item: IFAQItem) => void;
  close: () => void;
}

const CreateNewFAQModal: React.FC<ICreateNewFAQModalProps> = (props) => {
  const { onSave, close } = props;

  const textAreaTitle = useRef(null);
  const textArea = useRef(null);

  const saveNewItem = (): void => {
    if (textArea && textAreaTitle) {
      const newItemValue = {
        title: (textAreaTitle as any).current?.value,
        content: (textArea as any).current?.value,
      };

      onSave(newItemValue);
      close();
    }
  };

  return (
    <Box m={0} p={0} pt={1} pb={1}>
      <ModalTitle>Create New FAQ</ModalTitle>
      <ModalContentWrapper>
        <>
          <LabelArea>Title</LabelArea>
          <Input ref={textAreaTitle} placeholder="Title here" />
          <LabelArea>Content</LabelArea>
          <TextArea
            rows="10"
            ref={textArea}
            placeholder="# Start typing content here"
          />
        </>
        <Box mt={3}>
          <PrimaryButton onClick={saveNewItem}>Add FAQ</PrimaryButton>
          <CancelButton onClick={close}>Cancel</CancelButton>
        </Box>
      </ModalContentWrapper>
    </Box>
  );
};

export default CreateNewFAQModal;
